(() => {
  if (customElements.get('recommended-products')) {
    return;
  }

  class recommendedProducts extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('recommended-products');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // innerHTML assignment leaves any embedded <script> tags inert
              // (browsers don't execute scripts inserted this way). The KJM
              // grid add-to-cart behaviour + toast for these recommended
              // product cards lives in an inline <script> at the end of each
              // product-card.liquid render, so without this it silently never
              // wires up on pages (like /cart) where recommendations load via
              // this fetch+innerHTML path. Re-create each <script> tag so the
              // browser actually executes it.
              this.querySelectorAll('script').forEach((oldScript) => {
                const newScript = document.createElement('script');
                Array.from(oldScript.attributes).forEach((attr) => {
                  newScript.setAttribute(attr.name, attr.value);
                });
                newScript.textContent = oldScript.textContent;
                oldScript.replaceWith(newScript);
              });
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('recommended-products', recommendedProducts);
})();
